module.exports = __webpack_public_path__ + "img/logo2.179d7bec.png";